module.exports = __webpack_public_path__ + "static/media/joe-gardner-2.76ff47ae.jpg";